import { Fragment } from 'react';
import { ArtistTourType } from '@api';
import { ArtistAnchor, TourAnchor } from '@common';
import { Badge, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { getTourArtists } from './helpers';

type TourTableCellPropsType = {
  record: ArtistTourType;
};

export const TourTableCell: React.FC<TourTableCellPropsType> = ({ record }) => {
  const { t } = useTranslation('artistDetailsShows');
  const artists = getTourArtists(record);

  return (
    <Stack gap={0}>
      <Text>
        {artists.map((artist, index) => (
          <Fragment key={artist.id}>
            <ArtistAnchor artist={artist} />
            {index < artists.length - 1 && ' & '}
          </Fragment>
        ))}
      </Text>
      <TourAnchor tour={record.tour} />
      {record.isSupportAct && (
        <Badge color="blue">{t('ARTIST_SHOWS.SUPPORT_ACT')}</Badge>
      )}
    </Stack>
  );
};
